import { DatasetAccessLevel } from "datasets/types/enums/access-level";
import {
  EntityOverviewHeader,
  OverviewTile,
} from "~/pages/manifold-nextgen/components/EntityOverviewHeader";
import { SectionHeading } from "~/pages/manifold-nextgen/components/SectionHeading";
import { Timestamp } from "~/pages/manifold-nextgen/components/Timestamp";
import { AccessLevelBadge } from "~/pages/manifold-nextgen/components/datasets/AccessLevelBadge";
import { PersonalDatasetIcon } from "~/pages/manifold-nextgen/components/datasets/PersonalDatasetIcon";
import usePersonalDataset from "~/pages/manifold-nextgen/hooks/usePersonalDataset";

const PERSONAL_DATASET_NAME = "My Dataset";

export const PersonalDatasetOverview = () => {
  const { data: dataset } = usePersonalDataset();

  if (!dataset) {
    return null;
  }

  const tiles: OverviewTile[] = [
    {
      label: "Role",
      content: <AccessLevelBadge accessLevel={DatasetAccessLevel.OWNER} />,
    },
    {
      label: "Visibility",
      content: "Only you",
    },
    {
      label: "Created",
      content: <Timestamp value={dataset.created_at} />,
    },
  ];

  return (
    <div className="mx-auto w-full max-w-3xl pb-12 pt-4">
      <EntityOverviewHeader
        tiles={tiles}
        icon={<PersonalDatasetIcon size={36} />}
        title={PERSONAL_DATASET_NAME}
        type="Personal dataset"
      >
        <div className="flex flex-col gap-3">
          <SectionHeading title="About" />
          <p className="max-w-2xl text-sm text-muted-foreground">
            A private space only you can see. Agents write draft tables and views into your
            Snowflake schema, and files into your S3 prefix — none of it is shared with anyone else
            until you promote a table into a dataset you own.
          </p>
        </div>
      </EntityOverviewHeader>
    </div>
  );
};
